import type { UiKitLinkComponent, UIKitLinkProps } from "@qws-org/ui-kit";
import type { ForwardedRef } from "react";
import { forwardRef } from "react";
// eslint-disable-next-line boundaries/external
import { Link } from "react-router";

import { generateUrlWithLocale } from "~/i18n";

export const createLinkComponent = function (
  lang: LanguageCode,
): UiKitLinkComponent {
  return forwardRef<HTMLAnchorElement, UIKitLinkProps>(
    ({ children, href, ...rest }, ref: ForwardedRef<HTMLAnchorElement>) => {
      return (
        <Link
          {...rest}
          ref={ref}
          to={
            ["http", "mailto", "tel"].some((proto) => href?.startsWith(proto))
              ? (href ?? "/")
              : generateUrlWithLocale(href ?? "/", lang)
          }
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </Link>
      );
    },
  );
};
